import { useContext } from "react";
import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";
import GensetSLD from "../SLD/GensetSLD";
import PowerMeterSVG from "../SLD/PowerMeterSVG";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
const index =1;
const Genset = () =>{
     const {
    CBAssetList,
  } = useContext(DesignAssetContext);
   const isPMRequired = CBAssetList[index]?.uiData?.pmRequired || false; 
    return (
        <svg className="pointer">
           <GensetSLD   x = {610}   y = {140}/>
         { isPMRequired &&  <PowerMeterSVG
              id = {"_Genset"}
              x="615"
              y="127.5"
              index ={index}
            />}
            <CircuitBreakerSVG
              id={"_Genset"}
               x ={"710"}
              y ={"270"}
              index ={index}
               cbRequiredSelection = {true}
               name={CBAssetList[index]?.cbConfigData?.name || ""}
            />
        </svg>
    );
}
export default Genset;